import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { Workers } from 'src/app/models/Workers';

@Component({
  selector: 'app-dialog-dodaj-delavca',
  templateUrl: './dialog-dodaj-delavca.component.html',
  styleUrls: ['./dialog-dodaj-delavca.component.css']
})
export class DialogDodajDelavcaComponent implements OnInit, OnDestroy {
  public workers: Workers;
  public selectedWorker: Workers;
  public selectedAddDate;
  public dialogData;
  public communicationIdChat;

  constructor(
    private dialogRef: MatDialogRef<DialogDodajDelavcaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helpdeskService: HelpdeskService,
    private mainService: MainService,
    private loginPartner: LoginPartnerService,
    private _snackBar: MatSnackBar,
    private helpersService: HelpersService,
    private changeDetectorRef: ChangeDetectorRef 
  ) {
    this.dialogData = data;
  }

  ngOnInit() {
    this.helpdeskService.getWorkers(this.mainService.currentUserValue.sessionUser).subscribe(data => {
      this.workers = data.data.workers;
      console.log(this.workers);

      this.changeDetectorRef.detectChanges();
    });

    this.helpdeskService.currentHelpdeskParameters.subscribe(data => {
      this.communicationIdChat = data.communicationIdChat;
      console.log(this.communicationIdChat);

      this.changeDetectorRef.detectChanges();
    });
  }


  ngOnDestroy() {
    
  }

  save() {
    if(this.selectedWorker) {
      console.log(this.selectedWorker.code);
      let nextContact = null;
      if(this.selectedAddDate != 0) {
        nextContact = this.selectedAddDate;
      }
      //sessionUserPartner: string, userPartner: Partner, text: string, id, nextContact, workerId
      this.helpdeskService.setTaskWorker(this.loginPartner.currentPartnerValue, this.dialogData.taskText,
         this.dialogData.taskId, nextContact, this.selectedWorker.id, this.communicationIdChat).subscribe(
           data => {
             console.log(data);
           }
         );

      this.dialogRef.close(true);
    }  else {
      this.helpersService.openSnackBar('Izberite delavca!', 'Zapri');
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}
